// extracted by mini-css-extract-plugin
module.exports = {"container":"PopconfirmModal_container__BbqXd","title":"PopconfirmModal_title__2t5QJ","layout":"PopconfirmModal_layout__3787-","flex":"PopconfirmModal_flex__35D4i"};